<ng-content #form></ng-content>
<app-product-card
  (delete)="delete.emit($event)"
  [program]="program"
  [teamPath]="teamPath"
  [type]="BookingStorageEnum.education"
>
  <div class="col-12 col-md-7 d-flex flex-column">
    <div class="d-flex gap-2 flex-wrap mb-3">
      <div class="d-flex align-items-center border-end pe-2">
        <i class="bi bi-geo-alt me-2"></i>
        <div class="text-muted">{{ program.clinic.city }}</div>
      </div>
      <div class="d-flex align-items-center border-end pe-2">
        <i class="bi bi-person me-2"></i>
        <div>
          {{ 'for_whom' | transloco }}
          {{ program.forWhom | transloco }}
        </div>
      </div>
      @if (!program.hideDuration) {
        <div class="d-flex align-items-center">
          <i class="bi bi-clock me-2"></i>
          <div [innerHTML]="{ format: program.format, format_time: program.formatTime } | formatTime"></div>
        </div>
      }
    </div>

    <div class="d-flex align-items-center gap-2">
      <span class="text-muted">{{ 'format' | transloco }}</span>
      <span class="fw-bolder">{{ program.format | transloco }}</span>
    </div>

    @if (program.equipment) {
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">{{ 'equipment' | transloco }}:</span>
        <span class="fw-bolder">
          {{ program.equipment }}
        </span>
      </div>
    }
    @if (program.certificate) {
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">{{ 'certificate' | transloco }}</span>
        <span class="fw-bolder">
          {{ program.certificateType | transloco }}
          @if (program.certificatePoints) {
            <span> {{ 'certificate_points' | transloco: { points: program.certificatePoints } }} </span>
          }
        </span>
      </div>
    }
  </div>
</app-product-card>
